import { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../../config/apiConfig";

export function OtpPageView() {
  const navigate = useNavigate();
  const [otp, setOTP] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(""); // Single error state for better handling
  const email = localStorage.getItem("email"); // Get email from localStorage

  // Validate the OTP field
  const validateForm = () => {
    if (!otp.trim()) {
      setError("OTP is required");
      return false;
    }
    if (otp.length !== 6 || !/^\d{6}$/.test(otp)) {
      setError("OTP must be a valid 6-digit number");
      return false;
    }
    setError(""); // Clear any existing errors
    return true;
  };

  // Handle OTP verification
  const handleVerifyOTP = async (e) => {
    e.preventDefault();

    if (!validateForm()) return; // Stop if validation fails

    setLoading(true);

    // Retrieve email from localStorage
    const email = localStorage.getItem("email");
    if (!email) {
      setError("No email found in local storage. Please try again.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/api/user/auth/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("OTP verification successful:", data);

        // Navigate to Create Profile page and pass the email in state
        navigate("/create-profile", { state: { email } });
      } else {
        const errorData = await response.json();
        setError(errorData.message || "OTP verification failed");
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      setError("An error occurred during OTP verification. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(to right, #f8fafc, #eef3f8)",
        py: 6,
        px: 2,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 3,
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: 420,
          padding: { xs: 3, sm: 5 },
        }}
      >
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{ fontWeight: 600, color: "#333" }}
        >
          Verify OTP
        </Typography>

        <Typography
          variant="body2"
          align="center"
          sx={{
            color: "text.secondary",
            mb: 4,
            lineHeight: 1.6,
          }}
        >
          We’ve sent a 6-digit verification code to
          <strong> {email}</strong>. Please check your inbox and enter it below
          to continue.
        </Typography>

        <Box
          component="form"
          onSubmit={handleVerifyOTP}
          display="flex"
          flexDirection="column"
          alignItems="stretch"
        >
          <TextField
            fullWidth
            name="otp"
            label="Enter OTP"
            value={otp}
            onChange={(e) => setOTP(e.target.value)}
            error={!!error}
            helperText={error}
            sx={{ mb: 3 }}
            variant="outlined"
          />

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={loading}
            sx={{
              backgroundColor: "#51833a",
              color: "#fff",
              textTransform: "none",
              fontWeight: 500,
              borderRadius: 2,
              py: 1.4,
              "&:hover": {
                backgroundColor: "#446d2e",
              },
            }}
          >
            Verify
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );

}

export default OtpPageView;
